import { IRestrictedAccountObjectArgs, RestrictedAccountObject } from "../restricted-account-object/restricted-account-object.model";

export interface ILookupArgs extends IRestrictedAccountObjectArgs {
    title?: string;
    content?: string;
    sequence?: number;
    lookupType?: string;
}

const defaults = {
    title: "",
    content: "",
    sequence: 0,
    lookupType: ""
} as ILookupArgs;

export class Lookup extends RestrictedAccountObject {
    title: string;
    content: string;
    sequence: number;
    lookupType: string;

    constructor(data?: ILookupArgs) {
        super({...defaults, ...data} as any);
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/lookup/lookup.model.ts